export function getAxisClass(axis) {
    if (
        !axis ||
        typeof axis !== 'object' ||
        typeof axis.type !== 'number'
    ) {
        return ''
    }

    const type = axis.type
    const overload = axis.overload === true

    const baseIcon = 'icon-a'
    const typeSuffix = type > 1 ? `-${type}` : ''
    const overloadSuffix = overload ? '-ov' : ''

    const iconClass = `${baseIcon}${typeSuffix}${overloadSuffix}`
    const axisClass = `axis-icon${overload ? '-ov' : ''}${type > 1 ? `-${type}` : ''}`

    return `${iconClass} ${axisClass}`.trim()
}

export function getAxisNumberClass(axis) {
    if (!axis || typeof axis !== 'object') {
        return 'axle-field'
    }

    return axis.overload === true
        ? 'axle-field-red'
        : 'axle-field'
}

export function getWidthValue(axis) {
    if (!axis || typeof axis !== 'object') {
        return ''
    }

    return axis.type === 4 ? 'mr-8' : ''
}
